import axios from "@/plugins/axiosInstance";
import { dashboard } from "@/networking/urlManager";
import { responseHandlerService } from "@/plugins/responseHandlerService";

export async function fetchAnalyticsData(assetId, startDate, endDate) {
  try {
    // API parameters
    const params = { assetId: assetId };

    // Tarih aralığı parametrelerini ekle
    if (startDate && endDate) {
      params.startDate = startDate;
      params.endDate = endDate;
      console.log("Fetching analytics data with date range:", {
        startDate: params.startDate,
        endDate: params.endDate,
      });
    } else {
      console.log("Fetching analytics data with default date range");
    }

    const response = await axios.get(dashboard.getAnalyticsData, { params });

    console.log("Gelen veri:", response.data);
    console.log("Gelen data içeriği:", response.data.data);

    // API yanıtından veri ve durumları döndür
    if (response.data && response.data.data) {
      const analyticsData = response.data.data;

      return {
        data: analyticsData,
        isAuthorized: analyticsData.authorized !== false,
        hasPropertyId: analyticsData.hasPropertyId !== false,
        startDate: analyticsData.startDate,
        endDate: analyticsData.endDate,
        error: null,
      };
    }

    return {
      data: null,
      isAuthorized: true,
      hasPropertyId: true,
      error: null,
    };
  } catch (error) {
    console.error("Veri çekme hatası:", error);
    
    // Hata yanıtını kontrol et
    const errorData = error.response?.data?.data;
    const errorCode = error.response?.status;
    
    // 401 ve 403 hataları yetkilendirme sorunlarını gösterir
    const isAuthError = errorCode === 401 || errorCode === 403 || 
                       (errorData?.errorType === "ANALYTICS_DATA" && errorData?.isAuthError === true);
    
    // Hata tipine göre durum belirleme
    let isAuthorized = true;
    let hasPropertyId = true;
    
    if (isAuthError) {
      // Google yetkilendirme hatası
      isAuthorized = false;
      
      // Hata mesajını göster
      if (errorData?.error) {
        responseHandlerService.handleError(
          error,
          "Google Analytics hesabınızın yetkilendirmesi geçersiz. Lütfen ayarlar sayfasından yeniden bağlanın."
        );
      }
    } else if (errorData?.hasPropertyId === false) {
      // Mülk seçimi hatası
      hasPropertyId = false;
    }

    return {
      data: null,
      isAuthorized: isAuthorized,
      hasPropertyId: hasPropertyId,
      error: error,
    };
  }
}
